import { CalendarOffIcon } from '@/components/atoms/icons';
import { ContentDialog } from '@/components/molecules/dialogs/ContentDialog';
import { useAutoCloseOnVisible, useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppointmentLabels } from '../hooks/useAppointmentLabels';

export interface AppointmentCanceledDialogProps {
  visible: boolean;
  onDismiss: () => void;
  /** Auto-dismiss delay; defaults to 3000ms */
  autoCloseDelayMs?: number;
}

export function AppointmentCanceledDialog({
  visible,
  onDismiss,
  autoCloseDelayMs = 3000,
}: Readonly<AppointmentCanceledDialogProps>) {
  const colors = useUIColors();
  const labels = useAppointmentLabels();
  useAutoCloseOnVisible(visible, onDismiss, autoCloseDelayMs);

  return (
    <ContentDialog
      visible={visible}
      onClose={onDismiss}
      contentAlign="center"
      maxWidth={403}
      cardStyle={styles.card}
      headerStyle={styles.header}
      subtitleStyle={styles.subtitle}
      icon={
        <View style={styles.iconFrame}>
          <CalendarOffIcon size={ICON_SIZE} color={colors.fontPrimary} />
        </View>
      }
      title={labels.CANCELED_TITLE}
      titleVariant="title2"
      titleColor="primary"
      subtitle={labels.CANCELED_MESSAGE}
      subtitleVariant="body"
      subtitleColor="secondary"
      closeOnBackdropPress
    />
  );
}

const ICON_FRAME = 80;
const ICON_SIZE = 66.67;

const styles = StyleSheet.create({
  card: {
    width: '100%',
    maxWidth: 403,
    minHeight: 264,
    gap: 32,
    borderRadius: 16,
    paddingTop: 40,
    paddingBottom: 40,
    paddingHorizontal: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  header: {
    gap: 8,
    alignItems: 'center',
    width: '100%',
  },
  iconFrame: {
    width: ICON_FRAME,
    height: ICON_FRAME,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 4,
    marginTop: -8,
  },
  subtitle: {
    textAlign: 'center',
    alignSelf: 'center',
    maxWidth: 320,
    width: '100%',
    marginTop: 12,
  },
});

export default AppointmentCanceledDialog;
